import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

type SectionProps = IThemeProps<{}>;
export const Section = styled.section<SectionProps>`
  display: block;
  margin: 0 auto;
  min-height: ${(props: any) => props.theme.globals.minInteractionHeight};
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  height: 100%;
  min-height: ${(props: any) => props.theme.globals.minInteractionHeight};
  align-items: center;
  justify-content: center;
  flex-flow: column;
  padding: 20px;
`;

type TitleProps = IThemeProps<{}>;
export const Title = styled.h3<TitleProps>`
  display: block;
  margin: 0 auto;
  text-align: center;
  margin-top: 15px;
  font-size: ${(props: any) => props.theme.typography.h700};
  font-weight: ${(props: TitleProps) => props.theme.globals.fontWeightBold};
`;

type ContentBoxProps = IThemeProps<{}>;
export const ContentBox = styled.div<ContentBoxProps>`
  display: block;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  background-color: ${(props: ContentBoxProps) => props.theme.colors.white};
  margin-top: ${(props: ContentBoxProps) => props.theme.spacing.desktop.s400}px;
`;

type TextProps = IThemeProps<{}>;
export const Text = styled.p<TextProps>`
  display: block;
  margin: 0 auto;
  text-align: center;
  font-size: ${(props: any) => props.theme.typography.h700};
`;

type ButtonWrapProps = IThemeProps<{}>;
export const ButtonWrap = styled.div<ButtonWrapProps>`
  display: block;
  margin: 0 auto;
  margin-top: ${(props: ContentBoxProps) => props.theme.spacing.desktop.s400}px;
`;

export const SharingWrap = styled.div<IThemeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${(props: IThemeProps) => props.theme.spacing.desktop.s400}px;
  svg,
  path {
    fill: ${(props: IThemeProps) => props.theme.colors.button100};
  }
`;

type ImageProps = IThemeProps<{ showOnlyImage: boolean }>;
export const Image = styled.img<ImageProps>`
  position: relative;
  display: block;
  margin: 0 auto;
  overflow: hidden;

  background-color: ${(props: any) => props.theme.colors.white};
  border-color: ${(props: any) => props.theme.colors.white};
  border-style: solid;
  border-width: ${(props: any) => props.theme.borders.imageTile};
  box-shadow: ${(props: any) => props.theme.shadows.s200};

  width: 100%;
  height: auto;

  transition: all 0.25s ease-in;
  margin-top: ${(props: ImageProps) => (props.showOnlyImage ? "0" : "10px")};
`;
